<template>
  <div>
    <!-- 运行日汇总 -->
    <!-- 查询 -->
    <div style="display:flex;align-items: center; text-align:right">
      <summaryLevel @getLevel="getLevel" style="flex:1;margin-right:8px" ></summaryLevel>
      <quickQuery  :isMounted="false" @handleQuery="handleQuery" @quickQuery="quickQuery" @download="download" style="text-align: right"></quickQuery>
    </div>
    <!-- 表格 -->
    <div  class="page_container">
      <!-- <div class="page_table"> -->
        <el-table class="page_table" id="table" 
          :data="dataList" 
          :size="size" 
          border 
          @sort-change='sortChange' 
        >
          <el-table-column label="汇总单元名称" align="center" min-width="150" prop="comName" fixed="left"  class-name="fixd"></el-table-column>
          <!-- <el-table-column label="统计日期" align="center" min-width="120" prop="statDate" sortable="custom" fixed="left"  class-name="fixd"></el-table-column> -->
          <el-table-column label="运行时长(小时)" align="center" min-width="120" prop="runningTime"></el-table-column>
          <el-table-column label="驾驶时长(小时)" align="center" min-width="120" prop="drivingTime"></el-table-column>
          <el-table-column label="怠速时长(小时)" align="center" min-width="120" prop="idleTime"></el-table-column>
          <el-table-column label="怠速里程(公里)" align="center" min-width="120" prop="idleMileage"></el-table-column>
          <el-table-column label="怠速油耗(升)" align="center" min-width="120" prop="idleFuelCspt"></el-table-column>
          <el-table-column label="运行里程(公里)" align="center" min-width="120" prop="runningMileage"></el-table-column>
          <el-table-column label="百公里油耗(升/百公里)" min-width="150" align="center" prop="fuelCsptPer100km"></el-table-column>
          <el-table-column label="燃油消耗(升)" align="center" min-width="120" prop="fuelCspt"></el-table-column>
          <el-table-column label="耗电量" align="center" min-width="110" prop="powerCspt"></el-table-column>
          <el-table-column label="百公里耗电量" align="center" min-width="120" prop="powerCsptPer100km"></el-table-column>
          
        </el-table>
      <!-- </div> -->
    </div>
    <!-- 分页 -->
    <div>
      <kl-pagination  :total="total" @current-change="pageChange" :pageSize="pageSize"></kl-pagination>
    </div>
  </div>
</template>
<script>
import quickQuery from '../components/generalOrQuickQuery.vue'
import summaryLevel from '@/views/statistics/operationalData/components/summaryLevel'
export default {
  props:{
    size:{
      type:String,
    },
  },
  components:{summaryLevel,quickQuery},
  data(){
    return{
      dataList:[],
      tableWidth:undefined,
      total:3,
      pageSize:2,
      currentPage:0,
      showSum:true,
    }
  },
  computed:{
    list(){
      if(this.dataList != null && this.dataList.length > 0){
        return this.dataList.slice((this.currentPage - 1) * this.pageSize,this.currentPage * this.pageSize)
      }
    },
  },
  watch: {
  },
  methods:{
    getList(){
      this.dataList = [
      {
        "comName":"www",
        "statDate": "2023-10-26",
        "runningTime":280.26,
        "drivingTime":238.14,
        "idleTime":238.14,
        "idleMileage":238.14,
        "idleFuelCspt":238.14,
        "runningMileage":238.14,
        "fuelCsptPer100km":238.14,
        "fuelCspt":12,
        "powerCspt":12,
        "powerCsptPer100km":12,
      },
    ];
      this.total = this.dataList.length;
    },
    // 分页
    pageChange(val) {
      this.currentPage = val;
    },
    // 排序
    sortChange(column){
      // console.log("排序", column.prop, column.order);
      // this.currentPage = 1; // 排序后返回第一页
      this.dataList = this.dataList.sort(
        this.SortFun(column.prop, column.order === "descending")
      );
    },
    SortFun(attr, rev) {
      // console.log(rev)
      //第一个参数传入的prop表示排的是哪一列，第二个参数是升还是降排序
      if (rev == undefined) {
        rev = 1;
      } else {
        rev = rev ? 1 : -1;
        //rev = rev>0 ? 1 : -1;
      }
      return function (a, b) {
        a = a[attr];
        b = b[attr];
        // console.log(a,b);
        if (a < b) {
          return rev * -1;
        }
        if (a > b) {
          return rev * 1;
        }
        return 0;
      };
    },

    
    getLevel(level){
      console.log(level,"----------------------");
    },
    quickQuery(){},
    handleQuery(val){
      this.getList();
    },
    download(){
      console.log("导出");
    },
  },
  mounted(){
    this.dataList = [
      {
        "comName":"www",
        "statDate": "2023-10-26",
        "runningTime":280.26,
        "drivingTime":238.14,
        "idleTime":238.14,
        "idleMileage":238.14,
        "idleFuelCspt":238.14,
        "runningMileage":238.14,
        "fuelCsptPer100km":238.14,
        "fuelCspt":12,
        "powerCspt":12,
        "powerCsptPer100km":12,
      },
    ];
  }

}
</script>

<style lang="scss" scoped>

// 解决列表加入固定出现底部白条问题
::v-deep .el-table__fixed {
  height: 100% !important;
}
::v-deep .el-table__fixed-right {
  height: 100% !important;
}
</style>
